import { render, staticRenderFns } from "./ButtonEscape.vue?vue&type=template&id=85a21446&scoped=true"
import script from "./ButtonEscape.vue?vue&type=script&lang=js"
export * from "./ButtonEscape.vue?vue&type=script&lang=js"
import style0 from "./ButtonEscape.vue?vue&type=style&index=0&id=85a21446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a21446",
  null
  
)

export default component.exports